import React from "react";

const ProductTimelineCard = ({ product }) => {
    return (
        <div className="card mb-4">
            <div className="card-header">
                <h5 className="mb-0"> TIMELINE</h5>
            </div>
            <div className="card-body">
                <div className="row">
                    <div className="col-md-3">
                        <strong>Created At:</strong> {product.created_at ? new Date(product.created_at).toLocaleString() : '-'}
                    </div>
                    <div className="col-md-3">
                        <strong>Updated At:</strong> {product.updated_at ? new Date(product.updated_at).toLocaleString() : '-'}
                    </div>
                    <div className="col-md-3">
                        <strong>Approved At:</strong> {product.approved_at ? new Date(product.approved_at).toLocaleString() : '-'}
                    </div>
                    <div className="col-md-3">
                        <strong>Status:</strong> 
                        <span className={`badge ${product.status === 1 ? 'bg-success' : 'bg-danger'} ms-2`}>
                            {product.status === 1 ? 'Active' : 'Inactive'}
                        </span>
                    </div>
                    <div className="col-md-3 mt-2">
                        <strong>Views:</strong> {product.views || 0}
                    </div>
                    <div className="col-md-3 mt-2">
                        <strong>Rating:</strong> {product.rating_avg || '0.00'}
                    </div>
                    <div className="col-md-3 mt-2">
                        <strong>Total Reviews:</strong> {product.total_reviews || 0}
                    </div>
                    <div className="col-md-3 mt-2">
                        <strong>Total Orders:</strong> {product.total_orders || 0}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ProductTimelineCard;